import { Component, OnInit, } from '@angular/core';
import { AppConfigService } from '../../service/app-config.service';
import { PersonService } from '../../service/person.service';
declare var $: any;
@Component({
    selector: 'app-ourPartners',
    templateUrl: './ourPartners.component.html',
    styleUrls: ['./ourPartners.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})

export class OurPartnersComponent implements OnInit {
    showToggleId: number;
    showToggle: boolean;
    constructor() {
        
    }

    ngOnInit() {
        this.showToggle = false
        this.showToggleId = 0
    }

    onShowToggle(num) {
        console.log(num)
        if (this.showToggleId == num) {
            this.notShowToggle()
        } else {
            this.showToggleId = num;
            this.showToggle = true;
        }
    }

    notShowToggle() {
        this.showToggle = false;
        this.showToggleId = 0;
    }

}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/membership/ourPartners/ourPartners.component.ts